import { z } from "zod";

export type QcBizLocation = z.infer<typeof QcBizLocationSchema>;
export const QcBizLocationSchema = z.object({
  default_name: z.string().optional(),
  hash_value: z.string().optional().nullable(),
  id: z.number().optional(),
  is_default_location: z.boolean().optional(),
  is_room_asking: z
    .boolean()
    .nullable()
    .transform((value) => value ?? false),
  location_group_id: z.number().optional(),
  name: z.string().nullable().optional(),
  name_dict: z.string().optional(),
  pms_name: z.string().nullable().optional(),
  qr: z.string().optional().nullable(),
});
